const theme = {
  colors: {
    mainDark: "#5E091A",
    main: "#DC143C",
    mainLight: "#EC3257",

    secondaryLight: "#008BA7",
    secondaryDark: "#00728F",
    secondaryDarker: "#005B78",
    white: "#fafafa",
    whiteDarker: "#f0f0f0",
    whiteDarkest: "#ebede9",
    black: "#0d0c0d",
    blackLighter: "#231e1d",
  },
  spacing: {
    sidesLG: "20em",
    sidesMD: "12em",
    sidesSM: "8em",
    sidesXS: "1em",
  },
};

export default theme;
